import { Injectable, EventEmitter } from '@angular/core';
import { IFrameWorkEmitObject } from '@mmortgage/dynamic-form';
import { FormUtlityCommanFunction } from '@mmortgage/dynamic-form';
import { localTempObject } from '@mmortgage/dynamic-form';
import { IViewJsonModel, IViewValuesForm } from '@mmortgage/dynamic-form';
interface AddressFields {
    unit_number: string,
    street_number: string,
    street_name: string,
    direction: string,
    city: string,
    province: string,
    zip: string;
    country: string;
    address_line1?: string;
    address_line2?: string;
}

@Injectable()
export class FormPreScriptFunctions {

    private onPreScriptCompleteEmit: EventEmitter<IFrameWorkEmitObject>
        = new EventEmitter<IFrameWorkEmitObject>();
    private preScriformUliFunObj: FormUtlityCommanFunction;
    private preScritempLocalObj: localTempObject;
    private parentObj: any;
    private EnumData: any;
    private lang: any;
    private occupation_data = { 'occupationDetails': [{ 'category': '20', 'occupation': [{ 'occupationCode': '1001', 'subTypes': [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21] }, { 'occupationCode': '1002', 'subTypes': [22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34] }] }, { 'category': '21', 'occupation': [{ 'occupationCode': '1003', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1004', 'subTypes': [] }, { 'occupationCode': '1005', 'subTypes': [] }, { 'occupationCode': '1006', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1007', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1008', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1009', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1010', 'subTypes': [] }, { 'occupationCode': '1011', 'subTypes': [] }, { 'occupationCode': '1012', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1013', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1014', 'subTypes': [] }, { 'occupationCode': '1015', 'subTypes': [] }, { 'occupationCode': '1016', 'subTypes': [] }, { 'occupationCode': '1017', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1018', 'subTypes': [] }, { 'occupationCode': '1019', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1020', 'subTypes': [] }, { 'occupationCode': '1021', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1022', 'subTypes': [] }, { 'occupationCode': '1023', 'subTypes': [] }, { 'occupationCode': '1024', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1025', 'subTypes': [] }, { 'occupationCode': '1026', 'subTypes': [] }, { 'occupationCode': '1027', 'subTypes': [] }, { 'occupationCode': '1028', 'subTypes': [] }, { 'occupationCode': '1029', 'subTypes': [] }, { 'occupationCode': '1030', 'subTypes': [] }, { 'occupationCode': '1031', 'subTypes': [] }, { 'occupationCode': '1032', 'subTypes': [] }, { 'occupationCode': '1033', 'subTypes': [] }, { 'occupationCode': '1034', 'subTypes': [] }, { 'occupationCode': '1035', 'subTypes': [] }, { 'occupationCode': '1036', 'subTypes': [] }, { 'occupationCode': '1037', 'subTypes': [] }, { 'occupationCode': '1038', 'subTypes': [] }, { 'occupationCode': '1039', 'subTypes': [] }, { 'occupationCode': '1040', 'subTypes': [] }, { 'occupationCode': '1041', 'subTypes': [] }, { 'occupationCode': '1042', 'subTypes': [] }, { 'occupationCode': '1043', 'subTypes': [] }, { 'occupationCode': '1044', 'subTypes': [] }, { 'occupationCode': '1045', 'subTypes': [] }, { 'occupationCode': '1046', 'subTypes': [] }, { 'occupationCode': '1047', 'subTypes': [] }, { 'occupationCode': '1048', 'subTypes': [] }, { 'occupationCode': '1049', 'subTypes': [] }, { 'occupationCode': '1050', 'subTypes': [] }, { 'occupationCode': '1051', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1052', 'subTypes': [] }, { 'occupationCode': '1053', 'subTypes': [] }, { 'occupationCode': '1054', 'subTypes': [] }, { 'occupationCode': '1055', 'subTypes': [] }, { 'occupationCode': '1056', 'subTypes': [] }, { 'occupationCode': '1057', 'subTypes': [] }, { 'occupationCode': '1058', 'subTypes': [] }, { 'occupationCode': '1059', 'subTypes': [] }, { 'occupationCode': '1060', 'subTypes': [] }] }, { 'category': '22', 'occupation': [{ 'occupationCode': '1061', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1062', 'subTypes': [] }, { 'occupationCode': '1063', 'subTypes': [] }, { 'occupationCode': '1064', 'subTypes': [] }, { 'occupationCode': '1065', 'subTypes': [] }, { 'occupationCode': '1066', 'subTypes': [] }, { 'occupationCode': '1067', 'subTypes': [] }, { 'occupationCode': '1068', 'subTypes': [] }, { 'occupationCode': '1069', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1070', 'subTypes': [] }, { 'occupationCode': '1071', 'subTypes': [] }, { 'occupationCode': '1072', 'subTypes': [] }, { 'occupationCode': '1073', 'subTypes': [] }, { 'occupationCode': '1074', 'subTypes': [] }, { 'occupationCode': '1075', 'subTypes': [] }, { 'occupationCode': '1076', 'subTypes': [] }, { 'occupationCode': '1077', 'subTypes': [] }, { 'occupationCode': '1078', 'subTypes': [] }, { 'occupationCode': '1079', 'subTypes': [] }, { 'occupationCode': '1080', 'subTypes': [] }, { 'occupationCode': '1081', 'subTypes': [] }, { 'occupationCode': '1082', 'subTypes': [] }, { 'occupationCode': '1083', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1084', 'subTypes': [] }, { 'occupationCode': '1085', 'subTypes': [] }, { 'occupationCode': '1086', 'subTypes': [] }, { 'occupationCode': '1087', 'subTypes': [] }, { 'occupationCode': '1088', 'subTypes': [] }, { 'occupationCode': '1089', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1090', 'subTypes': [] }, { 'occupationCode': '1091', 'subTypes': [] }, { 'occupationCode': '1092', 'subTypes': [] }, { 'occupationCode': '1093', 'subTypes': [] }, { 'occupationCode': '1094', 'subTypes': [] }, { 'occupationCode': '1095', 'subTypes': [] }, { 'occupationCode': '1096', 'subTypes': [] }, { 'occupationCode': '1097', 'subTypes': [] }, { 'occupationCode': '1098', 'subTypes': [] }, { 'occupationCode': '1099', 'subTypes': [] }, { 'occupationCode': '1100', 'subTypes': [] }, { 'occupationCode': '1101', 'subTypes': [] }, { 'occupationCode': '1102', 'subTypes': [] }, { 'occupationCode': '1103', 'subTypes': [] }, { 'occupationCode': '1104', 'subTypes': [] }, { 'occupationCode': '1105', 'subTypes': [] }, { 'occupationCode': '1106', 'subTypes': [] }, { 'occupationCode': '1107', 'subTypes': [] }, { 'occupationCode': '1108', 'subTypes': [] }, { 'occupationCode': '1109', 'subTypes': [] }, { 'occupationCode': '1110', 'subTypes': [] }, { 'occupationCode': '1111', 'subTypes': [] }, { 'occupationCode': '1112', 'subTypes': [] }, { 'occupationCode': '1113', 'subTypes': [] }, { 'occupationCode': '1114', 'subTypes': [] }, { 'occupationCode': '1115', 'subTypes': [] }, { 'occupationCode': '1116', 'subTypes': [] }, { 'occupationCode': '1117', 'subTypes': [] }, { 'occupationCode': '1118', 'subTypes': [] }, { 'occupationCode': '1119', 'subTypes': [] }, { 'occupationCode': '1120', 'subTypes': [] }, { 'occupationCode': '1121', 'subTypes': [] }, { 'occupationCode': '1122', 'subTypes': [] }, { 'occupationCode': '1123', 'subTypes': [] }, { 'occupationCode': '1124', 'subTypes': [] }, { 'occupationCode': '1125', 'subTypes': [] }, { 'occupationCode': '1126', 'subTypes': [] }, { 'occupationCode': '1127', 'subTypes': [] }, { 'occupationCode': '1128', 'subTypes': [] }] }, { 'category': '23', 'occupation': [{ 'occupationCode': '1129', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1130', 'subTypes': [] }, { 'occupationCode': '1131', 'subTypes': [] }, { 'occupationCode': '1132', 'subTypes': [] }, { 'occupationCode': '1133', 'subTypes': [] }, { 'occupationCode': '1134', 'subTypes': [] }, { 'occupationCode': '1135', 'subTypes': [] }, { 'occupationCode': '1136', 'subTypes': [] }, { 'occupationCode': '1137', 'subTypes': [] }, { 'occupationCode': '1138', 'subTypes': [] }, { 'occupationCode': '1139', 'subTypes': [] }, { 'occupationCode': '1140', 'subTypes': [] }, { 'occupationCode': '1141', 'subTypes': [] }, { 'occupationCode': '1142', 'subTypes': [] }, { 'occupationCode': '1143', 'subTypes': [] }, { 'occupationCode': '1144', 'subTypes': [] }, { 'occupationCode': '1145', 'subTypes': [] }, { 'occupationCode': '1146', 'subTypes': [] }, { 'occupationCode': '1147', 'subTypes': [] }, { 'occupationCode': '1148', 'subTypes': [] }, { 'occupationCode': '1149', 'subTypes': [] }, { 'occupationCode': '1150', 'subTypes': [] }, { 'occupationCode': '1151', 'subTypes': [] }, { 'occupationCode': '1152', 'subTypes': [] }, { 'occupationCode': '1153', 'subTypes': [] }, { 'occupationCode': '1154', 'subTypes': [] }, { 'occupationCode': '1155', 'subTypes': [] }, { 'occupationCode': '1156', 'subTypes': [] }, { 'occupationCode': '1157', 'subTypes': [] }, { 'occupationCode': '1158', 'subTypes': [] }, { 'occupationCode': '1159', 'subTypes': [] }, { 'occupationCode': '1160', 'subTypes': [] }, { 'occupationCode': '1161', 'subTypes': [] }] }, { 'category': '24', 'occupation': [{ 'occupationCode': '1162', 'subTypes': [35, 36, 37, 38, 39, 40, 41] }, { 'occupationCode': '1163', 'subTypes': [42, 43, 44, 45] }, { 'occupationCode': '1164', 'subTypes': [42, 43, 44, 45] }, { 'occupationCode': '1165', 'subTypes': [42, 43, 44, 45] }, { 'occupationCode': '1174', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1166', 'subTypes': [] }, { 'occupationCode': '1167', 'subTypes': [] }, { 'occupationCode': '1168', 'subTypes': [] }, { 'occupationCode': '1169', 'subTypes': [] }, { 'occupationCode': '1170', 'subTypes': [] }, { 'occupationCode': '1171', 'subTypes': [] }, { 'occupationCode': '1172', 'subTypes': [] }, { 'occupationCode': '1173', 'subTypes': [] }, { 'occupationCode': '1175', 'subTypes': [] }, { 'occupationCode': '1176', 'subTypes': [] }] }, { 'category': '25', 'occupation': [{ 'occupationCode': '1177', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1178', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1179', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1180', 'subTypes': [] }, { 'occupationCode': '1181', 'subTypes': [] }, { 'occupationCode': '1182', 'subTypes': [] }, { 'occupationCode': '1183', 'subTypes': [] }, { 'occupationCode': '1184', 'subTypes': [] }, { 'occupationCode': '1185', 'subTypes': [] }, { 'occupationCode': '1186', 'subTypes': [] }, { 'occupationCode': '1187', 'subTypes': [] }, { 'occupationCode': '1188', 'subTypes': [] }, { 'occupationCode': '1189', 'subTypes': [] }, { 'occupationCode': '1190', 'subTypes': [] }, { 'occupationCode': '1191', 'subTypes': [] }, { 'occupationCode': '1192', 'subTypes': [] }, { 'occupationCode': '1193', 'subTypes': [] }, { 'occupationCode': '1194', 'subTypes': [] }, { 'occupationCode': '1200', 'subTypes': [] }, { 'occupationCode': '1201', 'subTypes': [] }, { 'occupationCode': '1202', 'subTypes': [] }, { 'occupationCode': '1203', 'subTypes': [] }, { 'occupationCode': '1204', 'subTypes': [] }, { 'occupationCode': '1205', 'subTypes': [] }, { 'occupationCode': '1206', 'subTypes': [] }, { 'occupationCode': '1207', 'subTypes': [] }, { 'occupationCode': '1209', 'subTypes': [] }, { 'occupationCode': '1210', 'subTypes': [] }, { 'occupationCode': '1211', 'subTypes': [] }, { 'occupationCode': '1195', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1196', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1197', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1198', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1199', 'subTypes': [54, 55] }, { 'occupationCode': '1208', 'subTypes': [56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97] }] }, { 'category': '26', 'occupation': [{ 'occupationCode': '1212', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1213', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1214', 'subTypes': [] }, { 'occupationCode': '1215', 'subTypes': [] }, { 'occupationCode': '1216', 'subTypes': [] }, { 'occupationCode': '1217', 'subTypes': [] }, { 'occupationCode': '1218', 'subTypes': [] }, { 'occupationCode': '1219', 'subTypes': [] }, { 'occupationCode': '1220', 'subTypes': [] }, { 'occupationCode': '1221', 'subTypes': [] }, { 'occupationCode': '1222', 'subTypes': [] }, { 'occupationCode': '1223', 'subTypes': [] }, { 'occupationCode': '1224', 'subTypes': [] }, { 'occupationCode': '1225', 'subTypes': [] }, { 'occupationCode': '1226', 'subTypes': [] }, { 'occupationCode': '1227', 'subTypes': [] }, { 'occupationCode': '1228', 'subTypes': [] }, { 'occupationCode': '1229', 'subTypes': [] }, { 'occupationCode': '1230', 'subTypes': [] }, { 'occupationCode': '1231', 'subTypes': [] }, { 'occupationCode': '1232', 'subTypes': [] }, { 'occupationCode': '1233', 'subTypes': [] }, { 'occupationCode': '1234', 'subTypes': [] }, { 'occupationCode': '1235', 'subTypes': [] }, { 'occupationCode': '1236', 'subTypes': [] }, { 'occupationCode': '1237', 'subTypes': [] }, { 'occupationCode': '1238', 'subTypes': [] }, { 'occupationCode': '1239', 'subTypes': [] }, { 'occupationCode': '1240', 'subTypes': [] }, { 'occupationCode': '1241', 'subTypes': [] }, { 'occupationCode': '1242', 'subTypes': [] }, { 'occupationCode': '1243', 'subTypes': [] }, { 'occupationCode': '1244', 'subTypes': [] }] }, { 'category': '27', 'occupation': [{ 'occupationCode': '1245', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1246', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1247', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1249', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1254', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1256', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1248', 'subTypes': [] }, { 'occupationCode': '1250', 'subTypes': [] }, { 'occupationCode': '1251', 'subTypes': [] }, { 'occupationCode': '1252', 'subTypes': [] }, { 'occupationCode': '1253', 'subTypes': [] }, { 'occupationCode': '1255', 'subTypes': [] }, { 'occupationCode': '1257', 'subTypes': [] }, { 'occupationCode': '1258', 'subTypes': [] }, { 'occupationCode': '1259', 'subTypes': [] }, { 'occupationCode': '1260', 'subTypes': [] }, { 'occupationCode': '1261', 'subTypes': [] }, { 'occupationCode': '1262', 'subTypes': [] }, { 'occupationCode': '1263', 'subTypes': [] }, { 'occupationCode': '1264', 'subTypes': [] }, { 'occupationCode': '1265', 'subTypes': [] }, { 'occupationCode': '1266', 'subTypes': [] }, { 'occupationCode': '1267', 'subTypes': [] }, { 'occupationCode': '1268', 'subTypes': [] }, { 'occupationCode': '1269', 'subTypes': [] }, { 'occupationCode': '1270', 'subTypes': [] }, { 'occupationCode': '1271', 'subTypes': [] }, { 'occupationCode': '1272', 'subTypes': [] }, { 'occupationCode': '1273', 'subTypes': [] }, { 'occupationCode': '1274', 'subTypes': [] }, { 'occupationCode': '1275', 'subTypes': [] }, { 'occupationCode': '1276', 'subTypes': [] }, { 'occupationCode': '1277', 'subTypes': [] }, { 'occupationCode': '1278', 'subTypes': [] }, { 'occupationCode': '1279', 'subTypes': [] }, { 'occupationCode': '1280', 'subTypes': [] }, { 'occupationCode': '1281', 'subTypes': [] }, { 'occupationCode': '1282', 'subTypes': [] }, { 'occupationCode': '1283', 'subTypes': [] }, { 'occupationCode': '1284', 'subTypes': [] }, { 'occupationCode': '1285', 'subTypes': [] }, { 'occupationCode': '1286', 'subTypes': [] }, { 'occupationCode': '1287', 'subTypes': [] }, { 'occupationCode': '1288', 'subTypes': [] }, { 'occupationCode': '1289', 'subTypes': [] }, { 'occupationCode': '1290', 'subTypes': [] }, { 'occupationCode': '1291', 'subTypes': [] }, { 'occupationCode': '1292', 'subTypes': [] }, { 'occupationCode': '1293', 'subTypes': [] }, { 'occupationCode': '1294', 'subTypes': [] }] }, { 'category': '28', 'occupation': [{ 'occupationCode': '1295', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1296', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1297', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1298', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1308', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1299', 'subTypes': [] }, { 'occupationCode': '1300', 'subTypes': [] }, { 'occupationCode': '1301', 'subTypes': [] }, { 'occupationCode': '1302', 'subTypes': [] }, { 'occupationCode': '1303', 'subTypes': [] }, { 'occupationCode': '1304', 'subTypes': [] }, { 'occupationCode': '1305', 'subTypes': [] }, { 'occupationCode': '1306', 'subTypes': [] }, { 'occupationCode': '1307', 'subTypes': [] }, { 'occupationCode': '1309', 'subTypes': [] }, { 'occupationCode': '1310', 'subTypes': [] }, { 'occupationCode': '1311', 'subTypes': [] }, { 'occupationCode': '1312', 'subTypes': [] }, { 'occupationCode': '1313', 'subTypes': [] }, { 'occupationCode': '1314', 'subTypes': [] }, { 'occupationCode': '1315', 'subTypes': [] }, { 'occupationCode': '1316', 'subTypes': [] }, { 'occupationCode': '1317', 'subTypes': [] }, { 'occupationCode': '1318', 'subTypes': [] }, { 'occupationCode': '1319', 'subTypes': [] }, { 'occupationCode': '1320', 'subTypes': [] }, { 'occupationCode': '1321', 'subTypes': [] }, { 'occupationCode': '1322', 'subTypes': [] }, { 'occupationCode': '1323', 'subTypes': [] }, { 'occupationCode': '1324', 'subTypes': [] }, { 'occupationCode': '1325', 'subTypes': [] }, { 'occupationCode': '1326', 'subTypes': [] }, { 'occupationCode': '1327', 'subTypes': [] }, { 'occupationCode': '1328', 'subTypes': [] }, { 'occupationCode': '1329', 'subTypes': [] }, { 'occupationCode': '1330', 'subTypes': [] }, { 'occupationCode': '1331', 'subTypes': [] }, { 'occupationCode': '1332', 'subTypes': [] }, { 'occupationCode': '1333', 'subTypes': [] }, { 'occupationCode': '1334', 'subTypes': [] }, { 'occupationCode': '1335', 'subTypes': [] }, { 'occupationCode': '1336', 'subTypes': [] }, { 'occupationCode': '1337', 'subTypes': [] }, { 'occupationCode': '1338', 'subTypes': [] }, { 'occupationCode': '1339', 'subTypes': [] }, { 'occupationCode': '1340', 'subTypes': [] }, { 'occupationCode': '1341', 'subTypes': [] }, { 'occupationCode': '1342', 'subTypes': [] }, { 'occupationCode': '1343', 'subTypes': [] }, { 'occupationCode': '1344', 'subTypes': [] }, { 'occupationCode': '1345', 'subTypes': [] }, { 'occupationCode': '1346', 'subTypes': [] }, { 'occupationCode': '1347', 'subTypes': [] }, { 'occupationCode': '1348', 'subTypes': [] }, { 'occupationCode': '1349', 'subTypes': [] }, { 'occupationCode': '1350', 'subTypes': [] }, { 'occupationCode': '1351', 'subTypes': [] }, { 'occupationCode': '1352', 'subTypes': [] }, { 'occupationCode': '1353', 'subTypes': [] }, { 'occupationCode': '1354', 'subTypes': [] }, { 'occupationCode': '1355', 'subTypes': [] }, { 'occupationCode': '1356', 'subTypes': [] }, { 'occupationCode': '1357', 'subTypes': [] }, { 'occupationCode': '1358', 'subTypes': [] }] }, { 'category': '29', 'occupation': [{ 'occupationCode': '1362', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1363', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1364', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1365', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1366', 'subTypes': [] }, { 'occupationCode': '1367', 'subTypes': [] }, { 'occupationCode': '1368', 'subTypes': [] }, { 'occupationCode': '1369', 'subTypes': [] }, { 'occupationCode': '1370', 'subTypes': [] }, { 'occupationCode': '1371', 'subTypes': [] }, { 'occupationCode': '1372', 'subTypes': [] }, { 'occupationCode': '1373', 'subTypes': [] }, { 'occupationCode': '1359', 'subTypes': [] }, { 'occupationCode': '1360', 'subTypes': [] }, { 'occupationCode': '1361', 'subTypes': [] }] }, { 'category': '30', 'occupation': [{ 'occupationCode': '1374', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1375', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1376', 'subTypes': [] }, { 'occupationCode': '1377', 'subTypes': [] }, { 'occupationCode': '1378', 'subTypes': [] }, { 'occupationCode': '1379', 'subTypes': [] }, { 'occupationCode': '1380', 'subTypes': [] }, { 'occupationCode': '1381', 'subTypes': [] }, { 'occupationCode': '1382', 'subTypes': [] }, { 'occupationCode': '1383', 'subTypes': [] }, { 'occupationCode': '1384', 'subTypes': [] }, { 'occupationCode': '1385', 'subTypes': [] }, { 'occupationCode': '1386', 'subTypes': [] }, { 'occupationCode': '1387', 'subTypes': [] }, { 'occupationCode': '1388', 'subTypes': [] }, { 'occupationCode': '1389', 'subTypes': [] }, { 'occupationCode': '1390', 'subTypes': [] }, { 'occupationCode': '1391', 'subTypes': [] }, { 'occupationCode': '1392', 'subTypes': [] }, { 'occupationCode': '1393', 'subTypes': [] }, { 'occupationCode': '1394', 'subTypes': [] }, { 'occupationCode': '1395', 'subTypes': [] }, { 'occupationCode': '1396', 'subTypes': [] }, { 'occupationCode': '1397', 'subTypes': [] }, { 'occupationCode': '1398', 'subTypes': [] }, { 'occupationCode': '1399', 'subTypes': [] }, { 'occupationCode': '1400', 'subTypes': [] }, { 'occupationCode': '1401', 'subTypes': [] }] }, { 'category': '31', 'occupation': [{ 'occupationCode': '1402', 'subTypes': [] }] }, { 'category': '32', 'occupation': [{ 'occupationCode': '1403', 'subTypes': [] }] }, { 'category': '33', 'occupation': [{ 'occupationCode': '1404', 'subTypes': [] }] }, { 'category': '34', 'occupation': [{ 'occupationCode': '1405', 'subTypes': [] }] }, { 'category': '35', 'occupation': [{ 'occupationCode': '1406', 'subTypes': [] }] }, { 'category': '36', 'occupation': [{ 'occupationCode': '1407', 'subTypes': [] }] }, { 'category': '37', 'occupation': [{ 'occupationCode': '1408', 'subTypes': [98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142] }] }] };
    setPreScriptIntValues(commFun: FormUtlityCommanFunction,
        tempObj: localTempObject, parentObj: any, enumObj: any, lang: any) {
        this.preScriformUliFunObj = commFun;
        this.preScritempLocalObj = tempObj;
        this.parentObj = parentObj;
        this.EnumData = enumObj;
        this.lang = lang;
    }
    onPNI_MortgageLoad(obj: IFrameWorkEmitObject) {
        try {
            if (obj.applicationDataObj.deal_details.mortgageObj.mortgage_discount_rate !== undefined &&
                obj.applicationDataObj.deal_details.mortgageObj.mortgage_discount_rate === '') {
                obj.applicationDataObj.deal_details.mortgageObj.mortgage_discount_rate = '0';
            }
          
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onPNI_MortgageLoad ::: Function in  - > form-PreScript-function.ts', e);
        }
    }
    onDSR_MortgageLoad(obj: IFrameWorkEmitObject) {
        try {
            if (obj.applicationDataObj.deal_details.mortgageObj.mortgage_discount_rate !== undefined &&
                obj.applicationDataObj.deal_details.mortgageObj.mortgage_discount_rate === '') {
                obj.applicationDataObj.deal_details.mortgageObj.mortgage_discount_rate = '0';
            }
          
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onDSR_MortgageLoad ::: Function in  - > form-PreScript-function.ts', e);
        }
    }
    onLoadOfDealPersonalDetails(obj: IFrameWorkEmitObject) {
        try {
            if (obj.applicationDataObj.borrower_info.relationship_type === '1') {
                obj.applicationDataObj.borrower_info.cost_borr_doc_pref = 'Y';
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onLoadOfDealPersonalDetails ::: Function in  - > form-PreScript-function.ts', e);
        }
    }
    onLoadSubjectProperty(obj: IFrameWorkEmitObject) {
        try {
            if (obj.applicationDataObj.property_details.unit_number === '') {
                obj.applicationDataObj.property_details.unit_number = '1';
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onLoadSubjectProperty ::: Function in  - > form-PreScript-function.ts', e);
        }
    }
 
    onRateDiscountDataChange(obj: IFrameWorkEmitObject) {
        try {
            if (obj.applicationDataObj.rate_discount !== '' && obj.applicationDataObj.rate_discount !== undefined) {
                const posted_rate = obj.applicationDataObj.posted_rate.slice(0, obj.applicationDataObj.posted_rate.length - 1);
                const client_rate = Number(posted_rate) - Number(obj.applicationDataObj.rate_discount);
                obj.applicationDataObj.client_rate = client_rate.toFixed(2);
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onRateDiscountDataChange ::: Function in  - > form-PreScript-function.ts', e);
        }
    }
    populateMortgageInsuranceProgram(obj: IFrameWorkEmitObject) {

        try {
            const mi_providers = this.EnumData['MORTGAGE_INSURANCE_PROVIDER'];
            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = [];
            if (obj.applicationDataObj.deal_details.mdiObj.mi_provider != null) {
                const mi_provider = obj.applicationDataObj.deal_details.mdiObj.mi_provider;
                const mi_program = obj.applicationDataObj.deal_details.mdiObj.mi_product_program ? obj.applicationDataObj.deal_details.mdiObj.mi_product_program : '';

                switch (Number(mi_provider)) {
                    case 1:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_CMHC_SPECIAL_PROGRAM'];
                        }
                        break;
                    case 2:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_CANADA_GUARANTY_SPECIAL_PROGRAM'];
                        }
                        break;
                    case 3:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_GENWORTH_SPECIAL_PROGRAM'];
                        }
                        break;
                    default:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_COMMON_SPECIAL_PROGRAM'];
                        }
                        break;

                }


            }
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > populateMortgageInsuranceProgram ::: Function in  - > form-preScript-function.ts', e)
        }

    }



    checkCIBCLiability(obj: IFrameWorkEmitObject) {
        try {
            // if Liability Source equals CIBC            
            let tempObj: any = this.preScritempLocalObj.temp;
            if (obj.applicationDataObj.cibc_Instrument_Indicator != undefined
                && obj.applicationDataObj.cibc_Instrument_Indicator === 'Y') {
                obj.applicationDataObj.isCIBCLiability = true;
            }
            else {
                obj.applicationDataObj.isCIBCLiability = false;
            }

            if (obj.applicationDataObj.Joint_with_Spouse) {
                if (obj.applicationDataObj.Joint_with_Spouse === 'true') {
                    obj.applicationDataObj.Joint_with_Spouse = 'Yes';
                } else if (obj.applicationDataObj.Joint_with_Spouse === 'false') {
                    obj.applicationDataObj.Joint_with_Spouse = 'No';
                }
            }


            let liability_type = obj.applicationDataObj.Liability_Type;
            if (obj.applicationDataObj.Liability_Source !== 'CVD') {
                tempObj.showMaturityDate = "true";
            } else {

                if (liability_type == '0' || liability_type == '302' || liability_type == '300' || liability_type == 'MTG') {
                    tempObj.showMaturityDate = "true";
                } else {
                    tempObj.showMaturityDate = "false";
                }

            }


            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > checkCIBCLiability ::: Function in  - > form-preScript-function.ts', e)
        }

    }


    onOccupationDataInit(obj: IFrameWorkEmitObject) {
        try {
            this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = [];
            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = [];
            let currEmpObj = obj.applicationDataObj.employment_info;
            if (currEmpObj) {
                let concatArrd = this.preScripBuildAddressDisplay(currEmpObj);
                let tempViewObj: any = obj.currentViewObj.viewValues;
                let tempAddrModel = tempViewObj[0].childElements[0].model;
                this.preScriformUliFunObj.getValuesForModel(tempAddrModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatArrd, true);
                let concatPhoneNum = '';
                if (currEmpObj.employer_phone !== '' && currEmpObj.employer_phone) {
                    concatPhoneNum = currEmpObj.employer_phone;
                    if (currEmpObj.phone_extension && currEmpObj.phone_extension !== '' && concatPhoneNum.indexOf('Ext') === -1) {
                        let extStr = (currEmpObj.phone_extension) ? currEmpObj.phone_extension : '';
                        if (this.lang === 'en') {
                            concatPhoneNum += ' ' + 'Extn :' + extStr;
                        }
                        if (this.lang === 'fr') {
                            concatPhoneNum += ' ' + 'Poste :' + extStr;
                        }
                    } else if (currEmpObj.employer_ext && currEmpObj.employer_ext !== '') {
                        let extStr = (currEmpObj.employer_ext) ? currEmpObj.employer_ext : '';
                        if (this.lang === 'en') {
                            concatPhoneNum += ' ' + 'Extn :' + extStr;
                        }
                        if (this.lang === 'fr') {
                            concatPhoneNum += ' ' + 'Poste :' + extStr;
                        }
                    }
                }
                let tempPhoneModel = tempViewObj[1].model;
                this.preScriformUliFunObj.getValuesForModel(tempPhoneModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatPhoneNum, true);
            }
            if (obj.applicationDataObj.employment_info.occupation_category) {
                const occupation_category = obj.applicationDataObj.employment_info.occupation_category ? obj.applicationDataObj.employment_info.occupation_category : '';
                const occupation_description = obj.applicationDataObj.employment_info.occupation_description ? obj.applicationDataObj.employment_info.occupation_description : '';
                const occupation_types = this.occupation_data.occupationDetails.find(occupation => occupation.category.toString().toLowerCase() === occupation_category.toString().toLowerCase());
                const tempOccupationTypeDesc = [];
                const tempOccupationTypeSubDesc = [];
                if (occupation_types) {
                    occupation_types.occupation.forEach(occupation => {
                        const enumMatchType = this.EnumData['OCCUPATION_TYPE_DESCRIPTION'].find(
                            enumData => enumData.keyCode.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase());
                        if (occupation_description && occupation_description.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase()) {
                            occupation.subTypes.forEach(subType => {
                                const enumMatchSubType = this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION'].find(
                                    enumData => enumData.keyCode.toString().toLowerCase() === subType.toString().toString().toLowerCase());
                                tempOccupationTypeSubDesc.push(enumMatchSubType);
                            });
                            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = tempOccupationTypeSubDesc;
                        }
                        tempOccupationTypeDesc.push(enumMatchType);
                    });
                    this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = tempOccupationTypeDesc;
                }

            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onOccupationDataInit ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    onAddEmploymentOccupationDataInit(obj: IFrameWorkEmitObject) {
        try {
            this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = [];
            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = [];
            if (obj.applicationDataObj.employment_info.occupation_category) {
                const occupation_category = obj.applicationDataObj.employment_info.occupation_category ? obj.applicationDataObj.employment_info.occupation_category : '';
                const occupation_description = obj.applicationDataObj.employment_info.occupation_description ? obj.applicationDataObj.employment_info.occupation_description : '';
                const occupation_types = this.occupation_data.occupationDetails.find(occupation => occupation.category.toString().toLowerCase() === occupation_category.toString().toLowerCase());
                const tempOccupationTypeDesc = [];
                const tempOccupationTypeSubDesc = [];
                if (occupation_types) {
                    occupation_types.occupation.forEach(occupation => {
                        const enumMatchType = this.EnumData['OCCUPATION_TYPE_DESCRIPTION'].find(
                            enumData => enumData.keyCode.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase());
                        if (occupation_description && occupation_description.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase()) {
                            occupation.subTypes.forEach(subType => {
                                const enumMatchSubType = this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION'].find(
                                    enumData => enumData.keyCode.toString().toLowerCase() === subType.toString().toString().toLowerCase());
                                tempOccupationTypeSubDesc.push(enumMatchSubType);
                            });
                            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = tempOccupationTypeSubDesc;
                        }
                        tempOccupationTypeDesc.push(enumMatchType);
                    });
                    this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = tempOccupationTypeDesc;
                }

            }


            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onAddEmploymentOccupationDataInit ::: Function in  - > form-preScript-function.ts', e)
        }
    }



    onPreScriptComplete(obj: IFrameWorkEmitObject) {
        try {
            this.onPreScriptCompleteEmit.emit(obj);

        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onPreScriptComplete ::: Function in  - > form-preScript-function.ts', e)
        }
    }
    onPreScriptCompleteInFramework() {
        try {
            return this.onPreScriptCompleteEmit;
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('onPreScriptCompleteInFramework ---> form-flow_framework.ts', e);
        }
    }
    concatCurrentAddress(obj: IFrameWorkEmitObject) {
        try {
            let currArrObj = obj.applicationDataObj.current_residence;
            if (currArrObj) {
                let concatArrd = this.preScripBuildAddressDisplay(currArrObj);
                let tempBuildAddrObj: any = obj.currentViewObj.viewValues[0];
                let tempAddrModel = tempBuildAddrObj.childElements[0].model;
                this.preScriformUliFunObj.getValuesForModel(tempAddrModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatArrd, true);
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > concatCurrentAddress ::: Function in  - > form-preScript-function.ts', e)
        }
    }
    concatPreviousAddress(obj: IFrameWorkEmitObject) {
        try {
            let currArrObj = obj.applicationDataObj.previous_residences[0];
            if (currArrObj) {

                let concatArrd = this.preScripBuildAddressDisplay(currArrObj);
                let tempBuildAddrObj: any = obj.currentViewObj.viewValues[0];
                let tempAddrModel = tempBuildAddrObj.childElements[0].model;
                this.preScriformUliFunObj.getValuesForModel(tempAddrModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatArrd, true);
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > concatPreviousAddress ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    EmploymentFormPrescript(obj: IFrameWorkEmitObject) {
        try {
            let currEmpObj = obj.applicationDataObj.currentEmpInfo;
            if (currEmpObj) {
                let concatArrd = this.preScripBuildAddressDisplay(currEmpObj);
                let tempViewObj: any = obj.currentViewObj.viewValues;
                let tempAddrModel = tempViewObj[0].childElements[0].model;
                this.preScriformUliFunObj.getValuesForModel(tempAddrModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatArrd, true);
                let concatPhoneNum = '';
                if (currEmpObj.employer_phone !== '' && currEmpObj.employer_phone) {
                    concatPhoneNum = currEmpObj.employer_phone;
                    if (currEmpObj.phone_extension && currEmpObj.phone_extension !== '' && concatPhoneNum.indexOf('Ext') === -1) {
                        let extStr = (currEmpObj.phone_extension) ? currEmpObj.phone_extension : '';
                        if (this.lang === 'en') {
                            concatPhoneNum += ' ' + 'Extn :' + extStr;
                        }
                        if (this.lang === 'fr') {
                            concatPhoneNum += ' ' + 'Poste :' + extStr;
                        }
                    } else if (currEmpObj.employer_ext && currEmpObj.employer_ext !== '') {
                        let extStr = (currEmpObj.employer_ext) ? currEmpObj.employer_ext : '';
                        if (this.lang === 'en') {
                            concatPhoneNum += ' ' + 'Extn :' + extStr;
                        }
                        if (this.lang === 'fr') {
                            concatPhoneNum += ' ' + 'Poste :' + extStr;
                        }
                    }
                }
                let tempPhoneModel = tempViewObj[1].model;
                this.preScriformUliFunObj.getValuesForModel(tempPhoneModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatPhoneNum, true);
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > EmploymentFormPrescript ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    PrevEmploFormPrescript(obj: IFrameWorkEmitObject) {
        try {
            let currPreObj = obj.applicationDataObj.previousEmpInfo;
            if (currPreObj) {
                let concatArrd = this.preScripBuildAddressDisplay(currPreObj);
                let tempViewObj: any = obj.currentViewObj.viewValues;
                let tempAddrModel = tempViewObj[0].childElements[0].model;
                this.preScriformUliFunObj.getValuesForModel(tempAddrModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatArrd, true);
                let concatPhoneNum = '';
                if (currPreObj.employer_phone !== '' && currPreObj.employer_phone) {
                    concatPhoneNum = currPreObj.employer_phone;
                    if (currPreObj.phone_extension !== '' && currPreObj.phone_extension !== '' && concatPhoneNum.indexOf('Ext') === -1) {
                        if (this.lang === 'en') {
                            concatPhoneNum += ' ' + 'Extn :' + currPreObj.phone_extension;
                        }
                        if (this.lang === 'fr') {
                            concatPhoneNum += ' ' + 'Poste :' + currPreObj.phone_extension;
                        }
                    } else if (currPreObj.employer_ext !== '' && currPreObj.employer_ext !== '') {
                        let extStr = (currPreObj.employer_ext) ? '' : currPreObj.employer_ext;
                        if (this.lang === 'en') {
                            concatPhoneNum += ' ' + 'Extn :' + currPreObj.phone_extension;
                        }
                        if (this.lang === 'fr') {
                            concatPhoneNum += ' ' + 'Poste :' + currPreObj.phone_extension;
                        }
                    }
                }
                let tempPhoneModel = tempViewObj[1].model;
                this.preScriformUliFunObj.getValuesForModel(tempPhoneModel, this.preScritempLocalObj,
                    obj.applicationDataObj, concatPhoneNum, true);
            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > EmploymentFormPrescript ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    getDirectionForCode(directionStr: string) {
        try {
            let retStr = '';
            switch (directionStr.toLocaleLowerCase()) {
                case 'north': retStr = 'N';
                    break;
                case 'south': retStr = 'S';
                    break;
                case 'east': retStr = 'E';
                    break;
                case 'west': retStr = 'W';
                    break;
                case 'north-east': retStr = 'NE';
                    break;
                case 'north-west': retStr = 'NW';
                    break;
                case 'south-east': retStr = 'SE';
                    break;
                case 'south-west': retStr = 'SW';
                    break;

                case 'nord': retStr = 'N';
                    break;
                case 'sud': retStr = 'S';
                    break;
                case 'est': retStr = 'E';
                    break;
                case 'ouest': retStr = 'W';
                    break;
                case 'nord-est': retStr = 'NE';
                    break;
                case 'nord-ouest': retStr = 'NW';
                    break;
                case 'sud-est': retStr = 'SE';
                    break;
                case 'sud-ouest': retStr = 'SW';
                    break;
            }
            return retStr;
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > getDirectionForCode ::: Function in  - > form-preScript-function.ts', e)
        }

    }

    preScripBuildAddressDisplay(addressObj: AddressFields) {
        try {
            let unitNum = (!addressObj.unit_number) ? '' : (addressObj.unit_number + '-');
            let strNum = (!addressObj.street_number) ? '' : (addressObj.street_number + ' ');
            let strNam = (!addressObj.street_name) ? '' : (addressObj.street_name + ' ');
            let direction = (!addressObj.direction) ? '' : addressObj.direction;
            if (direction !== '') {
                direction = this.getEnumKeyValue('STREET_DIRECTION', direction);
                direction = this.getDirectionForCode(direction);
            }
            let city = (!addressObj.city) ? '' : (addressObj.city + ', ');
            let province = (!addressObj.province) ? '' : (addressObj.province + ', ');
            let zip = (!addressObj.zip) ? '' : addressObj.zip;
            let country = (!addressObj.country) ? '' : addressObj.country;
            let address_line1 = (!addressObj.address_line1) ? '' : (addressObj.address_line1 + ' ');
            let address_line2 = (!addressObj.address_line2) ? '' : (addressObj.address_line2 + '-');
            if (country) {
                country = country.toString();
            }

            if (country === '1' || country === '2') {
                //temporary fix bcz api has 1 as keycode for country and same enum has no keycode as 1
            } else {
            }
            let concatArrd = '';


            concatArrd = address_line2 + address_line1 + ' ' + direction;
            concatArrd += '<br>' + city + province + zip;
            if (country && country.length > 0) {
                concatArrd += '<br>' + country;
            }
            return concatArrd;
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > preScripBuildAddressDisplay ::: Function in  - > form-preScript-function.ts', e);
        }
    }

    getEnumKeyValue(enumObjStr: string, enumKey: any) {
        try {
            let retStr = '';
            if (enumKey !== '') {
                enumKey = enumKey.toString();
               
            }
            return retStr;
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > getEnumKeyValue ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    setAddressValuesToModel(obj: IFrameWorkEmitObject) {
        try {
            let currView: IViewValuesForm = <IViewValuesForm>obj.currentViewObj.viewValues[0];
            let countryCode = this.preScriformUliFunObj.getValuesForModel(currView.model, this.preScritempLocalObj,
                obj.applicationDataObj, '', false);
            if (countryCode === '') {
                this.preScriformUliFunObj.getValuesForModel(currView.model, this.preScritempLocalObj,
                    obj.applicationDataObj, '146', true);
            }
            this.setAddressLine1AndTwo(obj);
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > setFormAddressValues ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    setAddressLine1AndTwo(obj: IFrameWorkEmitObject) {
        try {
            let streNum = obj.applicationDataObj.mailing_address.street_number;
            let streNam = obj.applicationDataObj.mailing_address.street_name;
            let UnitNum = obj.applicationDataObj.mailing_address.unit_number;
            let addrLin1 = "temp.mailing_address.addressLine1";
            let addrLin2 = "temp.mailing_address.addressLine2";
            let addrLin1Val = streNum + " " + streNam;
            this.preScriformUliFunObj.getValuesForModel(addrLin1, this.preScritempLocalObj,
                obj.applicationDataObj, addrLin1Val, true);
            this.preScriformUliFunObj.getValuesForModel(addrLin2, this.preScritempLocalObj,
                obj.applicationDataObj, UnitNum, true);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > setAddressLine1AndTwo ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    calculateLTV(obj: IFrameWorkEmitObject) {
        try {
            let requestedAmount = obj.applicationDataObj.transaction_details.deal_amount;
            let purchasePrice = obj.applicationDataObj.deal_details.purchase_price;
            let estimatedValue = obj.applicationDataObj.deal_details.estimated_value;
            let appraisedValue = obj.applicationDataObj.deal_details.appraised_value;
            let selectedProduct = obj.applicationDataObj.deal_details.selectedProductName;
            let hppLimit = '0';
            if (obj.applicationDataObj.deal_details.plc.hpp_limit !== undefined && obj.applicationDataObj.deal_details.plc.hpp_limit !== null) {
                hppLimit = obj.applicationDataObj.deal_details.plc.hpp_limit;
                hppLimit = hppLimit.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            }

            let LTV = 0;

            requestedAmount = requestedAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            purchasePrice = purchasePrice.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            appraisedValue = appraisedValue.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            estimatedValue = estimatedValue.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

            if (requestedAmount && requestedAmount.toString().length > 0) {
                if (purchasePrice && purchasePrice.toString().length > 0 && purchasePrice.toString() !== '0') {
                    //LTV = ((parseFloat(requestedAmount) / parseFloat(purchasePrice)) * 100);
                    if (selectedProduct === 'HPM') {
                        LTV = ((parseFloat(hppLimit) / parseFloat(purchasePrice)) * 100);
                    } else {
                        LTV = ((parseFloat(requestedAmount) / parseFloat(purchasePrice)) * 100);
                    }

                } else if (estimatedValue && estimatedValue.toString().length > 0 && estimatedValue.toString() !== '0') {
                    //LTV = ((parseFloat(requestedAmount) / parseFloat(estimatedValue)) * 100);
                    if (selectedProduct === 'HPM') {
                        LTV = ((parseFloat(hppLimit) / parseFloat(estimatedValue)) * 100);
                    } else {
                        LTV = ((parseFloat(requestedAmount) / parseFloat(estimatedValue)) * 100);
                    }
                } else if (appraisedValue && appraisedValue.toString().length > 0 && appraisedValue.toString() !== '0') {
                    //LTV = ((parseFloat(requestedAmount) / parseFloat(appraisedValue)) * 100);
                    if (selectedProduct === 'HPM') {
                        LTV = ((parseFloat(hppLimit) / parseFloat(appraisedValue)) * 100);
                    } else {
                        LTV = ((parseFloat(requestedAmount) / parseFloat(appraisedValue)) * 100);
                    }
                }
                if (obj.applicationDataObj.deal_details.mdiObj.default_insurance_required === undefined) {
                    obj.applicationDataObj.deal_details.mdiObj['default_insurance_required'] = '';
                }
                if ((LTV) > 80) {
                    obj.applicationDataObj.deal_details.mdiObj.default_insurance_required = 'Y';
                } else {
                    obj.applicationDataObj.deal_details.mdiObj.default_insurance_required =
                        obj.applicationDataObj.deal_details.mdiObj.default_insurance_required;
                }
            }

            this.populateMortgageInsuranceProgram(obj);
            this.onPreScriptComplete(obj);

        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > setAddressLine1AndTwo ::: Function in  - > form-preScript-function.ts', e)
        }

    }

    calculatePLCClientRate(obj: IFrameWorkEmitObject) {
        try {
            if (obj.applicationDataObj.plc) {
                let percentagePrime = obj.applicationDataObj.plc.percentage_of_prime;
                let spreadAbovePrime = obj.applicationDataObj.plc.percentage_of_spreadaboveprime;
                let clientRate = 0;

                percentagePrime = percentagePrime.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
                spreadAbovePrime = spreadAbovePrime.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

                if ((percentagePrime && percentagePrime.toString().length > 0 && percentagePrime.toString() !== '') &&
                    (spreadAbovePrime && spreadAbovePrime.toString().length > 0 && spreadAbovePrime.toString() !== '')) {
                    clientRate = (parseFloat(percentagePrime) + parseFloat(spreadAbovePrime));
                } else if (percentagePrime && percentagePrime.toString().length > 0 && percentagePrime.toString() !== '') {
                    clientRate = parseFloat(percentagePrime);
                } else if (spreadAbovePrime && spreadAbovePrime.toString().length > 0 && spreadAbovePrime.toString() !== '') {
                    clientRate = parseFloat(spreadAbovePrime);
                } else {
                    clientRate = 0;
                }

                if (clientRate && clientRate.toString() !== '') {
                    obj.applicationDataObj.plc.percentage_of_client_rate = (clientRate.toFixed(2)).toString();
                } else {
                    obj.applicationDataObj.plc.percentage_of_client_rate = '0';
                }
            }


            this.onPreScriptComplete(obj);

        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > calculatePLCClientRate ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    onThirdPartyOccupationDataInit(obj: IFrameWorkEmitObject) {
        try {
            this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = [];
            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = [];
            if (obj.applicationDataObj.third_party_application.occupation_category) {
                const occupation_category = obj.applicationDataObj.third_party_application.occupation_category ? obj.applicationDataObj.third_party_application.occupation_category : '';
                const occupation_description = obj.applicationDataObj.third_party_application.occupation_description ? obj.applicationDataObj.third_party_application.occupation_description : '';
                const occupation_types = this.occupation_data.occupationDetails.find(occupation => occupation.category.toString().toLowerCase() === occupation_category.toString().toLowerCase());
                const tempOccupationTypeDesc = [];
                const tempOccupationTypeSubDesc = [];
                if (occupation_types) {
                    occupation_types.occupation.forEach(occupation => {
                        const enumMatchType = this.EnumData['OCCUPATION_TYPE_DESCRIPTION'].find(
                            enumData => enumData.keyCode.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase());
                        if (occupation_description && occupation_description.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase()) {
                            occupation.subTypes.forEach(subType => {
                                const enumMatchSubType = this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION'].find(
                                    enumData => enumData.keyCode.toString().toLowerCase() === subType.toString().toString().toLowerCase());
                                tempOccupationTypeSubDesc.push(enumMatchSubType);
                            });
                            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = tempOccupationTypeSubDesc;
                        }
                        tempOccupationTypeDesc.push(enumMatchType);
                    });
                    this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = tempOccupationTypeDesc;
                }

            }


            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onThirdPartyOccupationDataInit ::: Function in  - > form-preScript-function.ts', e)
        }
    }


    onHPPDataInit(obj: IFrameWorkEmitObject) {
        try {
            this.setHPPLimit(obj);
            this.onPreScriptComplete(obj);
        }
        catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onHPPDataInit ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    setHPPLimit(obj: IFrameWorkEmitObject) {

        let requestedMortgageAmount = obj.applicationDataObj.transaction_details.deal_amount;
        let requestedPLCAmount = obj.applicationDataObj.deal_details.plc.plc_requested_Limit;
        let hppLimit = 0;

        requestedMortgageAmount = requestedMortgageAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
        requestedPLCAmount = requestedPLCAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

        if ((requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') &&
            (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '')) {
            hppLimit = (parseFloat(requestedMortgageAmount) + parseFloat(requestedPLCAmount));
        } else if (requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') {
            hppLimit = parseFloat(requestedMortgageAmount);
        } else if (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '') {
            hppLimit = parseFloat(requestedPLCAmount);
        } else {
            hppLimit = 0;
        }

        if (hppLimit && hppLimit.toString() !== '') {
            obj.applicationDataObj.deal_details.plc.hpp_limit = (hppLimit.toFixed(2)).toString();
        } else {
            obj.applicationDataObj.deal_details.plc.hpp_limit = '0';
        }


        let chargeAmountOption = obj.applicationDataObj.deal_details.plc.collateral_charge;
        let chargeAmount = obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount
        let getModel = obj.applicationDataObj.deal_details;

        if (chargeAmountOption) {
            if (chargeAmountOption === '1') {
                if (getModel.purchase_price && getModel.purchase_price !== '') {
                    obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount = getModel.purchase_price.toString();
                } else if (getModel.estimated_value && getModel.estimated_value !== '') {
                    obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount = getModel.estimated_value.toString();
                } else if (getModel.appraised_value && getModel.appraised_value !== '') {
                    obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount = getModel.appraised_value.toString();
                } else {
                    obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount = '0';
                }
            }
            if (chargeAmountOption === '2') {
                if (hppLimit && hppLimit.toString() !== '') {
                    obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount = (hppLimit.toFixed(2)).toString();
                }
                else {
                    obj.applicationDataObj.deal_details.plc.hppSectionDetails.charge_amount = '0';
                }
            }
        }
    }
    onRefinanceDetailInit(obj: IFrameWorkEmitObject) {
        try {

            this.onPreScriptComplete(obj);
        }
        catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onRefinanceDetailInit ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    assignRefinanceDetails(obj: IFrameWorkEmitObject) {

    }

    checkExistingRelationship(applicant: any, relationship: any) {
        let relationship_status_exist: any;
        let selectOption: any = [];
        if (relationship.toString() === "2") {
            relationship_status_exist = "3"
            selectOption.push('1');
            selectOption.push('3');
            return selectOption;
        } else if (relationship.toString() === "5") {
            relationship_status_exist = "4"
            selectOption.push('1');
            selectOption.push('4');
            return selectOption;
        }
        return selectOption;
    }

    onAddApplicantInit(obj: IFrameWorkEmitObject) {
        try {
            this.EnumData['SELECTED_APPLICANT_DETAILS'] = [];
            let tempOption = [];
            let test: any;
            if (obj.applicationDataObj.applicant_list !== undefined && obj.applicationDataObj.applicant_list !== null) {
                obj.applicationDataObj.applicant_list = '';
                const relationship_type = obj.applicationDataObj.relationship_type ? obj.applicationDataObj.relationship_type : '';
                if (relationship_type && relationship_type.toString().length > 0) {
                    const occupation_types = this.EnumData['APPLICANT_DETAILS'].filter(e => (
                         e.borrwerIndex.toString() === '0' && e.applicantId.toString() === '0' &&
                        (this.checkExistingRelationship(e, relationship_type) &&
                            this.checkExistingRelationship(e, relationship_type).length > 0) &&
                        (e.relationshipType === (this.checkExistingRelationship(e, relationship_type))[0]) ||
                        (e.relationshipType === (this.checkExistingRelationship(e, relationship_type))[1])));
                    occupation_types.forEach((element, index) => {
                        let Option = {};
                        if (element.borrwerIndex.toString() === '0' && (element.isApplicantAddEnable || element.isApplicantAddEnable.toString === 'true')) {
                            Option = {
                                keyCode: element.applicantId.toString() + '#' + element.borrwerIndex + '#' + element.borrowerName,//index,Liability_Source
                                keyValue: element.borrowerName
                            };
                            tempOption.push(Option);
                        }

                    });
                }

                if (tempOption.length <= 0) {
                    let Option = {
                        keyCode: '-1',
                        keyValue: 'Not Available'
                    };
                    tempOption.push(Option);
                }
                this.EnumData['SELECTED_APPLICANT_DETAILS'] = tempOption;

            }
            this.onPreScriptComplete(obj);
        } catch (e) {
            this.preScriformUliFunObj.displayErrorInConsole('Error - > onOccupationDataInit ::: Function in  - > form-preScript-function.ts', e)
        }
    }


}
